const dataLayer: any[] =
  //@ts-ignore
  typeof window !== "undefined" && Array.isArray(window.dataLayer)
    ? //@ts-ignore
      window.dataLayer
    : [];

export function pushToDataLayer(event: string, data: Record<string, any>) {
  dataLayer.push({
    event: event,
    ...data,
  });
}
